import React, { Component } from 'react';
import styleable from 'react-styleable';
import '../../styles/core.scss';
import css from './booking-fee-disclaimer.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BOOKING_FEE_DISCLAIMER_FETCHED } from './booking-fee-disclaimer-actions';
import { fetchPost } from '../helpers/common-actions';
import { LoadingGeneric } from '../loading';

@styleable(css)
class BookingFeeDisclaimer extends Component {
  static propTypes = {
    css: React.PropTypes.object,
    data: React.PropTypes.object,
    fetchPost: React.PropTypes.func,
    route: React.PropTypes.object,
    bookingFeeDisclaimerReducer: React.PropTypes.array,
    textDisclaimer: React.PropTypes.bool,
    showPopup: React.PropTypes.bool,
    agentId: React.PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {
        protocol: null,
        host: null,
        agentId: null
      },
      noDataFound: false,
      bookingFeeDisclaimerApiUrl: 'booking/api/search/getBookingFeeAllRules'
    };
  }

  componentDidMount() {
    const { agentId, domain } = this.props;
    this.state.data.domain = domain;
    this.state.data.agentId = agentId;

    this.fetchBookingFee();
  }

  fetchBookingFee() {
    const baseURL = this.props.baseURL ? this.props.baseURL : `${window.location.protocol}//${window.location.hostname}/`;

    this.props.fetchPost({
      dataUrl: `${baseURL}${this.state.bookingFeeDisclaimerApiUrl}`,
      data: this.state.data,
      dataAcquiredType: BOOKING_FEE_DISCLAIMER_FETCHED,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      successCallBack: this.success,
      failCallBack: () => {
      }
    });
  }

  success = () => {
    this.state.noDataFound = true;
  }

  render() {
    const { bookingFeeDisclaimerReducer, textDisclaimer } = this.props;
    let bookingFeeRuleText = '';
    bookingFeeDisclaimerReducer.map((item) => {
      if (bookingFeeDisclaimerReducer.length > 1 && bookingFeeRuleText !== '') {
        bookingFeeRuleText = `${bookingFeeRuleText}, ${item.ruleFullText}`;
      } else {
        bookingFeeRuleText = item.ruleFullText;
      }
    });
    return (
      <span>
        {!textDisclaimer? (
          <div className={`hwrld ${css.hwrld}`} >
            <div className={`hwrld ${css.hwrld}`}>
              <div>
                <span className={css.title}>
                Booking Fees Apply
                </span>
              </div>
              <div className={css['bookingfee-info']}>
                <div >
                  {bookingFeeDisclaimerReducer.length !== 0 ? (
                  <div>
                    <table>
                      <tbody>
                        {bookingFeeDisclaimerReducer.map((item) =>
                          <tr>
                            <td><b>{item.ruleType}&nbsp;</b></td>
                            <td>
                              <table>
                                <tbody>
                                  {item.ruleModels.map((model) =>
                                  <tr>
                                    <td>{model.rulePopupText}</td>
                                  </tr>
                                  )}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div><br /><p>© {new Date().getFullYear()} Helloworld Travel Limited.
                      Helloworld Travel Services (Australia)
                      Pty Limited<br />(ABN {bookingFeeDisclaimerReducer[0].abnText}) trading as {bookingFeeDisclaimerReducer[0].tradingName}</p></div>
                  </div>
                  ) : (
                    !this.state.noDataFound ? (
                      <div className={css.loading}>
                        <LoadingGeneric>Loading Booking Fee Info</LoadingGeneric>
                      </div>
                    ) : (
                      <div>No Fee</div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          bookingFeeDisclaimerReducer.length !== 0 && bookingFeeRuleText !== '' ? (
            <span> The following Booking fees will apply, <b>{bookingFeeRuleText}</b>.</span>
          ) : (
            ''
          )
        )}
      </span>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookingFeeDisclaimerReducer: state.bookingFeeDisclaimerReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPost
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingFeeDisclaimer);
